export enum ResultType {
    Success = 1,
    Error,
    Warning,
    NotAuthorized,
}
